<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.25065 20.1666H13.7507C18.334 20.1666 20.1673 18.3333 20.1673 13.75V8.24998C20.1673 3.66665 18.334 1.83331 13.7507 1.83331H8.25065C3.66732 1.83331 1.83398 3.66665 1.83398 8.24998V13.75C1.83398 18.3333 3.66732 20.1666 8.25065 20.1666Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>